module.exports = "/packs/images/svg/ireland/facilities/day_pass~16e9e7a4bd17bc8ab3875bdada9179c5.svg";